import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCallback, useRef } from 'react';
import { jobContextMenu } from './jobContextMenu';

// Typically, ChainList displays a single Job, in which case jobId will be provided, and module is not needed.
// In an OrgDetail UI, several Chain Jobs may be displayed, so only module is provided. JobDataPlugin will
// return all of the relevant Jobs
export const ChainList = ({ jobId, module }) => {

  const rsrc = useRsrc();

  const entityListRef = useRef();
  const jobIds = useRef([]);

  const augFieldDefs = (fieldToFieldDef) => {
    const nameFieldDef = fieldToFieldDef.name;
    nameFieldDef.autoGrouping = true;
    nameFieldDef.precedence = -1000;

    // GridConstants.removeAuditFieldDefs(fieldToFieldDef);
    fieldToFieldDef.code.hide = true;

    fieldToFieldDef.verStartInstant.sort = null;
  }

  const clientSideRowData = useCallback((setDataSource) => {
    const reqParam = { jobId, module };
    rsrc.data('skdr', 'JOB_DATA_PLUGIN', reqParam).then((res) => {
      const gridApi = entityListRef.current?.gridRef?.current?.gridApiRef?.current;

      if (!jobIds.current.length || !gridApi) {
        setDataSource(res);
      } else {
        gridApi.applyTransaction({ update: res });
      }

      jobIds.current = res.map(job => job.id);
    })
  }, [jobId]);

  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    contextMenus.push(...jobContextMenu(rsrc, params));
    return contextMenus;
  }

  return (
    <EntityList
      ref={entityListRef}
      module="skdr"
      entity="JOB"
      augFieldDefs={augFieldDefs}
      clientSideRowData={clientSideRowData}
      gridOptions={{
        treeData: true,
        getContextMenuItems,
        getRowId: (params) => String(params.data?.id)
      }}
    />
  )
}